<template>
<!--公司简介 关于我们-->
  <div id="introduction">
    <h2 class="title">
      <a @click="back" class="prev"></a>
      关于我们
    </h2>
    <h1>简介</h1>
    <div class="main" v-html="textData">
      <!--
      <p>
        距离2019年还有一个半月的时间，除华为外，国产手机2018年的旗舰手机已经发布。在这一年里，国产手机始终围绕“全面屏”做文章，从刘海屏，到水滴屏，还有诸如Find X和vivo NEX的另类全面屏。
      </p>
      <p>
        最近两年，手机行业遭遇创新瓶颈。在小米、夏普相继推出全面屏手机后，拉开了全面屏普及的序幕。严格来说，2017年更像是全面屏的试水元年。在苹果刘海屏被众多国产手机品牌疯狂吐槽后，国产手机开始围绕全面屏做文章，试图抛弃苹果全面屏这一个非常丑陋的方案。
      </p>
      <p>
        在很多人看来，苹果全面屏手机iPhone X上市后，以华为、OPPO和vivo为代表的国产手机品牌都推出了刘海屏手机，这是一种模仿。严格来说，华为P20和OPPO的R15同样是刘海式的全面屏，但刘海面积要比iPhone X小很多。单纯从技术角度来说，在更小的空间里，堆积同样的硬件，对技术的要求也比较高
      </p>
      -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'Introduction',
  data () {
    return {
      textData: {}
    }
  },
  methods: {
    getText () {
      let data = {
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_company_Introduction',
        params: data,
        headers: {
          'sign': this.$encryption(data)
        }
      })
        .then(res => {
          this.textData = res.data
        })
        .catch(err => { console.log(err) })
    },
    back () {
      if (window.history.length <= 1) {
        this.$router.push({path: '/'})
      } else {
        this.$router.go(-1)
      }
    }
  },
  mounted () {
    this.getText()
  }
}
</script>

<style scoped lang="stylus">
  #introduction
    .title
      position: relative
      height: 1.08rem
      line-height: .8rem
      background-color: transparent
      padding: .14rem .16rem
      font-size: .32rem
      color: #050505
      font-weight: 600
      text-align: center
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      a.prev
        position: absolute
        top: .14rem
        left: .16rem
        display: block
        width: .8rem
        height: .8rem
        background-color: #fff
        -webkit-border-radius: 50%
        -moz-border-radius: 50%
        border-radius: 50%
        &::before
          content: ""
          position: absolute
          top: .3rem
          left: .32rem
          display: block
          width: .20rem
          height: .20rem
          border-left: .03rem solid #050505
          border-bottom: .03rem solid #050505
          -webkit-transform: rotate(45deg)
          -moz-transform: rotate(45deg)
          -ms-transform: rotate(45deg)
          -o-transform: rotate(45deg)
          transform: rotate(45deg)
    h1
      padding: 0 .4rem
      margin: .28rem 0
      font-size: .48rem
      color: #050505
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
    .main
      padding: 0 .4rem
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      p
        line-height: .5rem
        margin-top: .28rem
        font-size: .32rem
        color: #333
        text-align: justify
        text-indent: 2em
</style>



// WEBPACK FOOTER //
// src/components/single/Introduction.vue